import { Grid } from "antd-mobile";
import styled from "styled-components";
import {fmoney} from '../../../../utils/utils'
export default function Notice({item}) {

  return (
    <Wrapper>
      <Text>恭喜中獎！本次獲得</Text>
      <Grid columns={3}>
        <Grid.Item>
          <Squre>
            <img src="/image/RB.png" alt=""></img>
            <p> {fmoney(item.rb,2)}</p>
          </Squre>
        </Grid.Item>
        <Grid.Item>
          <Squre>
            <img src="/image/quility_chip.png" alt=""></img>
            <p>{fmoney(item.rbct,2)}</p>
          </Squre>
        </Grid.Item>
        <Grid.Item>
          <Squre>
            <img src="/image/equip_chip.png" alt=""></img>
            <p>{fmoney(item.rbet,2)}</p>
          </Squre>
        </Grid.Item>
      </Grid>
      <Text>將直接發放至您的遊戲賬戶</Text>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  text-align: center;
`;

const Text = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 1.6rem;
  line-height: 1.6rem;
  color: #000;
  span {
    color: #ff5c00;
  }
`;
const Squre = styled.div`
  background: #f4f5f6;
  border-radius: 1.6rem;

  width: 8.6rem;
  height: 8.6rem;
  margin: 2.0rem auto;
  padding: 1.5rem 1.6rem;
  box-sizing: border-box;
  img {
    width: 2.6rem;
  }
  p {
    font-style: normal;
    font-weight: 600;
    font-size: 1.6rem;
    line-height: 2.0rem;
    color: #000000;
    margin-top: .5rem;
  }
`;
